export const ROLE_MGS_ADMIN = 'ROLE_ADMIN';
export const ROLE_MGS_SUPER_ADMIN = 'ROLE_SUPERADMIN';
export const ROLE_MGS_USER = 'ROLE_USER';
export const ROLE_MGS_KIDS = 'ROLE_KIDS';
export const ROLE_MGS_USER_FOR_KIDS_TERMIN = 'ROLE_USER_FOR_KIDS_TERMIN';
export const ROLE_MGS_ARZT = 'ROLE_ARZT';
export const ROLE_MGS_PHARMAKOGENETIK = 'ROLE_PHARMAKOGENETIK';
export const ROLE_MGS_INSTAHELP = 'ROLE_INSTAHELP';
export const ROLE_MGS_SPOWI = 'ROLE_SPOWI';
export const ROLE_MGS_BUCHUNG = 'ROLE_BUCHUNG';
export const ROLE_MGS_REZEPTION = 'ROLE_REZEPTION';
export const ROLE_MGS_ABRECHNUNG = 'ROLE_ABRECHNUNG';

export const ROLE_MGS_FALLDATEN = 'ROLE_FALLDATEN';

export type MgsRole =
  | typeof ROLE_MGS_ADMIN
  | typeof ROLE_MGS_SUPER_ADMIN
  | typeof ROLE_MGS_USER
  | typeof ROLE_MGS_KIDS
  | typeof ROLE_MGS_ARZT
  | typeof ROLE_MGS_SPOWI
  | typeof ROLE_MGS_BUCHUNG
  | typeof ROLE_MGS_REZEPTION
  | typeof ROLE_MGS_ABRECHNUNG
  | typeof ROLE_MGS_USER_FOR_KIDS_TERMIN
  | typeof ROLE_MGS_PHARMAKOGENETIK
  | typeof ROLE_MGS_INSTAHELP
  | typeof ROLE_MGS_FALLDATEN;

// Rollen die ein Admin für einen "normalen" User (usertype===2) über das UI vergeben kann
export const zuordenbarebareRollen: MgsRole[] = [ROLE_MGS_ARZT, ROLE_MGS_SPOWI, ROLE_MGS_REZEPTION];

export const zuordenbareRollenFuerBuchungsPartner: MgsRole[] = [ROLE_MGS_BUCHUNG, ROLE_MGS_ABRECHNUNG];

export const alleZuordenbareRollen = [...zuordenbarebareRollen, ...zuordenbareRollenFuerBuchungsPartner];

export const ermittleZuordenbareRollen = (isBuchungPartner: boolean) =>
  isBuchungPartner ? zuordenbareRollenFuerBuchungsPartner : zuordenbarebareRollen;

export const isZuordenbareRolle = (role: string) => alleZuordenbareRollen.some((currentRole) => role === currentRole);

export const rollenLabelsKurz = {
  [ROLE_MGS_ADMIN]: 'Admin',
  [ROLE_MGS_SUPER_ADMIN]: 'Super Admin',
  [ROLE_MGS_USER]: 'User',
  [ROLE_MGS_KIDS]: 'Kids',
  [ROLE_MGS_ARZT]: 'Arzt',
  [ROLE_MGS_SPOWI]: 'Spowi',
  [ROLE_MGS_BUCHUNG]: 'Buch.',
  [ROLE_MGS_REZEPTION]: 'Rez.',
  [ROLE_MGS_ABRECHNUNG]: 'Abrech.',
  [ROLE_MGS_FALLDATEN]: 'Falld.'
};

export const rollenLabels = {
  [ROLE_MGS_ADMIN]: 'Admin',
  [ROLE_MGS_SUPER_ADMIN]: 'Super Admin',
  [ROLE_MGS_USER]: 'User',
  [ROLE_MGS_KIDS]: 'Kids',
  [ROLE_MGS_ARZT]: 'Arzt',
  [ROLE_MGS_SPOWI]: 'Sportwissenschafter',
  [ROLE_MGS_BUCHUNG]: 'Buchung',
  [ROLE_MGS_REZEPTION]: 'Rezeption',
  [ROLE_MGS_ABRECHNUNG]: 'Abrechnung',
  [ROLE_MGS_FALLDATEN]: 'Falldaten'
};
